// Per-user grid density preference. Persisted to localStorage so it
// survives reloads. Tenant-agnostic on purpose — density is a personal
// reading preference, not a workspace setting.

import { useEffect, useState } from 'react';

export type Density = 'compact' | 'comfortable';

const KEY = 'cc.grid.density';

function read(): Density {
  if (typeof window === 'undefined') return 'comfortable';
  return window.localStorage.getItem(KEY) === 'compact' ? 'compact' : 'comfortable';
}

export function useDensity(): [Density, (d: Density) => void] {
  const [density, setDensity] = useState<Density>(read);
  useEffect(() => {
    const handler = () => setDensity(read());
    window.addEventListener('cc:grid-density', handler);
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener('cc:grid-density', handler);
      window.removeEventListener('storage', handler);
    };
  }, []);
  function set(d: Density) {
    window.localStorage.setItem(KEY, d);
    window.dispatchEvent(new Event('cc:grid-density'));
    setDensity(d);
  }
  return [density, set];
}
